const { api } = require("../api-calls/user-requests");
const { LANGUAGE } = require("../api-calls/api-urls");
const { setLanguageJsonData } = require("../Redux/actions/user-actions");
const store = require("../Redux/store").default;

export const getLanguagedataFunction = async (dispatch) => {
  const existing = store.getState()?.allUsers?.language_json;
  if (existing) return;

  let lan = localStorage.getItem("language") || "en";
  if (!localStorage.getItem("language")) {
    localStorage.setItem("language", "en");
  }
  if (lan === "undefined" || lan === "null") {
    lan = "en";
  }

  try {
    // Ensure lan is a simple string, not a JSON object
    if (typeof lan === "object") {
      lan = lan.code || "en";
    }

    const { data } = await api.get(`${LANGUAGE}/${lan}`);
    console.log("Language data fetched successfully:", data);
    dispatch(setLanguageJsonData(data));
  } catch (error) {
    console.error("Error fetching language data:", error);
    // Set default English data if API fails
    dispatch(setLanguageJsonData({ language: "en", data: {} }));
  }
};
